import React from 'react'
import './homepage.css'

const Homepage = () => {
  return (
    <main role="main" id="home-section" className="homepage">
      <h1>HUNTER<br/>TREADAWAY</h1>
      <h3>Project Manager</h3>
      <h4>Delivering digital products from concept to completion.</h4>
      <p alt="a custom font is used which transforms alpha-numeric characters in to pixel monsters" className="character-container">&nbsp;</p>
    </main>
  )
}

export default Homepage